/* ============================================================================
   NURA SOLIS — THEME.JS (Shopify)
   Chrome & interactions partagées : barre d'annonce, menu mobile, tiroir
   panier (AJAX Cart API), accordéons, bannière cookies, flèches du mini-slider
   produit, fiche produit (galerie/quantité/ajout).
   ========================================================================== */
(function () {
  "use strict";
  var R = window.NURA_ROUTES || {};

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }

  var fmt;
  function money(cents, currency) {
    try {
      if (!fmt) fmt = new Intl.NumberFormat("fr-FR", { style: "currency", currency: currency || "EUR" });
      return fmt.format((cents || 0) / 100);
    } catch (e) { return ((cents || 0) / 100).toFixed(2) + " €"; }
  }

  /* --- Barre d'annonce (rotation) ----------------------------------------- */
  (function announce() {
    var bar = $(".announce"); if (!bar) return;
    var msgs = (bar.getAttribute("data-messages") || "").split("||").filter(Boolean);
    if (msgs.length < 2) return;
    var txt = $(".announce__text", bar), idx = 0, INTERVAL = 4000;
    function show(n) {
      idx = (n + msgs.length) % msgs.length;
      txt.classList.add("is-fading");
      setTimeout(function () { txt.textContent = "✦ " + msgs[idx]; txt.classList.remove("is-fading"); }, 200);
    }
    var auto = setInterval(function () { show(idx + 1); }, INTERVAL);
    function restart() { clearInterval(auto); auto = setInterval(function () { show(idx + 1); }, INTERVAL); }
    var prev = $("#ann-prev", bar), next = $("#ann-next", bar);
    if (prev) prev.onclick = function () { show(idx - 1); restart(); };
    if (next) next.onclick = function () { show(idx + 1); restart(); };
  })();

  /* --- Menu mobile -------------------------------------------------------- */
  (function menu() {
    var m = $("#m-menu"), btn = $("#open-menu"); if (!m || !btn) return;
    function open() { m.setAttribute("aria-hidden", "false"); btn.setAttribute("aria-expanded", "true"); document.body.style.overflow = "hidden"; }
    function close() { m.setAttribute("aria-hidden", "true"); btn.setAttribute("aria-expanded", "false"); document.body.style.overflow = ""; }
    btn.onclick = open;
    $all("[data-menu-close]", m).forEach(function (b) { b.onclick = close; });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  })();

  /* --- Nav : état "scrolled" (transparent sur le hero de l'accueil) ------- */
  (function navScroll() {
    var nav = $("#nav"); if (!nav) return;
    var isHome = document.body.classList.contains("home");
    function onScroll() {
      var threshold = isHome ? window.innerHeight * 0.7 : 10;
      nav.classList.toggle("scrolled", window.scrollY > threshold);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  })();

  /* --- Accordéons --------------------------------------------------------- */
  $all(".acc__btn").forEach(function (btn) {
    var panel = btn.nextElementSibling;
    btn.setAttribute("aria-expanded", "false");
    btn.onclick = function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
      panel.style.maxHeight = open ? "0px" : panel.scrollHeight + "px";
    };
  });

  /* ======================= PANIER (AJAX Cart API) ========================= */
  var cart = $("#cart"), lastFocus = null;
  function openCart() { if (!cart) return; lastFocus = document.activeElement; cart.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; var c = $(".cart__close", cart); if (c) c.focus(); }
  function closeCart() { if (!cart) return; cart.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; if (lastFocus) lastFocus.focus(); }
  var openBtn = $("#open-cart"); if (openBtn) openBtn.onclick = openCart;
  if (cart) $all("[data-cart-close]", cart).forEach(function (b) { b.onclick = closeCart; });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

  function updateCount(n) {
    $all(".cart-count").forEach(function (b) { b.textContent = n; if (n === 0) b.setAttribute("hidden", ""); else b.removeAttribute("hidden"); });
  }

  function renderDrawer(data) {
    var body = $("#cart-body"); if (!body) return;
    if (!data.items || !data.items.length) {
      body.innerHTML = '<div class="cart__empty"><p>Votre panier est vide.</p><a class="btn btn--ghost btn-sm" href="' + (R.cart_url || "/cart") + '" style="margin-top:16px">Découvrir la boutique</a></div>';
    } else {
      body.innerHTML = data.items.map(function (i) {
        return '<div class="cart-item">' +
          '<div class="cart-item__img">' + (i.image ? '<img src="' + i.image + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : "") + "</div>" +
          "<div><div class=\"cart-item__title\">" + i.product_title + "</div>" +
          (i.variant_title && i.variant_title.indexOf("Default") === -1 ? '<div class="cart-item__variant">' + i.variant_title + "</div>" : "") +
          '<div class="qty" data-key="' + i.key + '"><button type="button" data-act="dec" aria-label="Diminuer">−</button><input type="text" value="' + i.quantity + '" readonly aria-label="Quantité"><button type="button" data-act="inc" aria-label="Augmenter">+</button></div>' +
          '<button class="cart-item__remove" data-remove="' + i.key + '">Retirer</button></div>' +
          '<div class="cart-item__price">' + money(i.final_line_price, data.currency) + "</div>" +
        "</div>";
      }).join("");
    }
    var sub = $("#cart-subtotal"); if (sub) sub.textContent = money(data.total_price, data.currency);
    updateCount(data.item_count);
    bindDrawer();
  }

  function refreshCart(openIt) {
    fetch((R.cart_url || "/cart") + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data); if (openIt) openCart(); });
  }

  function changeLine(key, qty) {
    fetch(R.cart_change || "/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (data) { renderDrawer(data); });
  }

  function bindDrawer() {
    $all("#cart-body .qty").forEach(function (q) {
      var key = q.getAttribute("data-key");
      var cur = parseInt(q.querySelector("input").value, 10);
      q.querySelector('[data-act="dec"]').onclick = function () { changeLine(key, Math.max(0, cur - 1)); };
      q.querySelector('[data-act="inc"]').onclick = function () { changeLine(key, cur + 1); };
    });
    $all("#cart-body [data-remove]").forEach(function (b) { b.onclick = function () { changeLine(b.getAttribute("data-remove"), 0); }; });
  }
  bindDrawer();

  /* Ajout au panier depuis la fiche produit */
  var pform = $("#product-form");
  function submitProductForm() {
    var btn = pform.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(R.cart_add || "/cart/add.js", { method: "POST", body: new FormData(pform), headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(true); })
      .catch(function () { pform.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  }
  if (pform) {
    pform.addEventListener("submit", function (e) { e.preventDefault(); submitProductForm(); });
  }
  var stickyAdd = $("#sticky-add");
  if (stickyAdd && pform) stickyAdd.onclick = function () { submitProductForm(); };

  /* --- Fiche produit : galerie + quantité ---------------------------------- */
  (function pdp() {
    var main = $("#pdp-main-img");
    $all(".pdp__thumbs button").forEach(function (b) {
      b.onclick = function () {
        if (main) main.src = b.getAttribute("data-src");
        $all(".pdp__thumbs button").forEach(function (x) { x.setAttribute("aria-current", "false"); });
        b.setAttribute("aria-current", "true");
      };
    });
    var qi = $("#q-input");
    if (qi) {
      var dec = $("#q-dec"), inc = $("#q-inc");
      if (dec) dec.onclick = function () { qi.value = Math.max(1, parseInt(qi.value, 10) - 1); };
      if (inc) inc.onclick = function () { qi.value = parseInt(qi.value, 10) + 1; };
    }
  })();

  /* --- Mini-slider dans les cartes produit : flèches ‹ › + barres --------- */
  document.body.addEventListener("click", function (e) {
    var arrow = e.target.closest(".card-slider__arrow");
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    var slider = arrow.closest(".card-slider");
    var count = parseInt(slider.dataset.count, 10);
    var idx = (parseInt(slider.dataset.idx, 10) + parseInt(arrow.dataset.dir, 10) + count) % count;
    slider.dataset.idx = idx;
    slider.querySelector(".card-slider__track").style.transform = "translateX(-" + (idx * 100) + "%)";
    slider.querySelectorAll(".card-slider__bars span").forEach(function (b, i) { b.classList.toggle("is-active", i === idx); });
  });

    /* --- Pop-up newsletter (-10% à l'inscription) ---------------------------- */
  (function newsletterPopup() {
    var p = $("#newsletter-popup"); if (!p) return;
    var KEY = "nura_newsletter_popup";
    function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function open() { p.classList.add("show"); document.body.style.overflow = "hidden"; }
    function close() { p.classList.remove("show"); document.body.style.overflow = ""; set("dismissed"); }
    $all("[data-popup-close]", p).forEach(function (b) { b.onclick = close; });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && p.classList.contains("show")) close(); });

    if (p.dataset.posted === "1") { open(); set("subscribed"); return; }
    if (stored()) return;
    var delay = parseInt(p.dataset.delay, 10) || 4000;
    setTimeout(open, delay);
  })();



  /* --- Bannière cookies ---------------------------------------------------- */
  (function cookies() {
    var b = $("#cookies"); if (!b) return;
    var KEY = "nura_cookie_consent";
    function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    if (!stored()) b.classList.add("show");
    function set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} b.classList.remove("show"); }
    var a = $("#ck-accept"), r = $("#ck-refuse");
    if (a) a.onclick = function () { set("all"); };
    if (r) r.onclick = function () { set("necessary"); };
  })();
})();
